import { AssistentItem, AssistentCustomFormItem } from '../assistent_config';
import { EigenstromButtonWrapper } from './wrapper/EigenstromButtonWrapper';
import { IDs } from '../../../../helpers/IDs';
import * as React from 'react';
import { StromButtonWrapper } from './wrapper/StromButtonWrapper';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getAssistentConfigStrom(standort: any, data: any, jahr: number, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    const showElektrofahrzeuge = true; /*!!(data[IDs.ENT_KONFIGURATION] || [])
        .some((param: any) => param.daten_elektrofahrzeuge_orig === 1);*/
    const customFormConfig = {
        gebaeude_tid: { show: false },
        ...(showElektrofahrzeuge ? {} : { seperate_abrechnung_emobil_strom: { hidden: true } })
    };
    const eingabe_strom = {
        gliederung: '2.1',
        name: 'Strom',
        dataName: 'Strom',
        description: 'Dies ist das Formular zur Eingabe der Strom-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_ENERGIEDATEN_STROM,
        style: { marginLeft: '18px' },
        addLabel: 'Neuen Strom-Datensatz/Zähler erfassen',
        configFlag: 'inputStrom',
        customFormConfig,
        customOnChange: customOnChange,
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_STROM);
        },
        // customTopElement: (entity: string, item: any, callback?: (data: any) => void) =>
        //     <StromButtonWrapper
        //         jahr={jahr}
        //         standortSelected={standort}
        //         values={item}
        //         data={data}
        //         callback={callback}
        //     />
        getExtraElement: (tmp1: boolean, tmp2: any, tmp3: number, tmp4: any, values: any, setValues: (values: any) => void, disabled?: boolean) =>
            values.abrechnungsmodus === 2 // {2} Monatsrechnungen
                ? <StromButtonWrapper
                    jahr={jahr}
                    standortSelected={standort}
                    values={values}
                    data={data}
                    callback={setValues}
                    disabled={disabled}
                />
                : null,
        ...(customCfg || {})
    };
    return eingabe_strom;
}

// function customOnChange(dataItem: any, data: any, contextService: any) {
//     if (!dataItem.tid || dataItem.tid === 0) {
//         if (dataItem.strom_dritte_orig === 1 || dataItem.strom_dritte === 1) {
//             showStromDritteMessage();
//             return;
//         }
//         if (dataItem.seperate_abrechnung_emobil_strom_orig === 1 || dataItem.seperate_abrechnung_emobil_strom === 1) {
//             showLadestromMessage();
//             return;
//         }
//     } else {
//         const arr = data[IDs.ENT_ENERGIEDATEN_STROM] || [];
//         const found = arr.find((item: any) => item.tid === dataItem.tid);
//         // console.log(dataItem, found);
//         if (found) {
//             if (
//                 (dataItem.strom_dritte_orig === 1 || dataItem.strom_dritte === 1)
//                 && (!found.strom_dritte_orig || found.strom_dritte_orig !== 1 || !dataItem.strom_dritte_orig)
//             ) {
//                 showStromDritteMessage();
//                 dataItem.strom_dritte_orig = 1;
//                 return;
//             } else if (
//                 (dataItem.strom_dritte === 1 && !found.strom_dritte)
//                 || (dataItem.strom_dritte === 1 && dataItem.strom_dritte_name === 'Nein')
//             ) {
//                 showStromDritteMessage();
//                 dataItem.strom_dritte_orig = 1;
//                 return;
//             }
//             if ((dataItem.seperate_abrechnung_emobil_strom_orig === 1 || dataItem.seperate_abrechnung_emobil_strom === 1) &&
//                 (!found.seperate_abrechnung_emobil_strom_orig || found.seperate_abrechnung_emobil_strom_orig !== 1 ||
//                     !dataItem.seperate_abrechnung_emobil_strom_orig)) {
//                 showLadestromMessage();
//                 dataItem.seperate_abrechnung_emobil_strom_orig = 1;
//                 return;
//             } else if (
//                 (dataItem.seperate_abrechnung_emobil_strom === 1 && !found.seperate_abrechnung_emobil_strom)
//                 || (dataItem.seperate_abrechnung_emobil_strom === 1 && dataItem.seperate_abrechnung_emobil_strom_name === 'Nein')
//             ) {
//                 showLadestromMessage();
//                 dataItem.seperate_abrechnung_emobil_strom_orig = 1;
//                 return;
//             }
//         }
//         if (dataItem.strom_dritte_name === 'Nein' || dataItem.strom_dritte === 2) {
//             dataItem.strom_dritte_orig = '';
//         }
//         if (dataItem.seperate_abrechnung_emobil_strom_name === 'Nein' || dataItem.seperate_abrechnung_emobil_strom === 2) {
//             dataItem.seperate_abrechnung_emobil_strom_orig = '';
//         }
//     }
// }

function customOnChange(dataItem: any, dataGlobal: any, contextService: any, prevDataItem: any) {
    // console.log(dataItem, prevDataItem);
    if (
        // Neuer Datensatz
        (dataItem.tid === 0 && dataItem.strom_dritte === 1) ||
        // Erste Bearbeitung
        (!prevDataItem.hasOwnProperty('tid') && dataItem.strom_dritte_name !== 'Ja' && dataItem.strom_dritte === 1) ||
        // Spätere Bearbeitung
        (prevDataItem.hasOwnProperty('strom_dritte') && prevDataItem.strom_dritte !== 1 && dataItem.strom_dritte === 1) ||
        (prevDataItem.hasOwnProperty('strom_dritte_orig') && prevDataItem.strom_dritte_orig !== 1 && dataItem.strom_dritte_orig === 1)
    ) {
        showStromDritteMessage(dataGlobal);
        return;
    }
    if (
        // Neuer Datensatz
        (dataItem.tid === 0 && dataItem.seperate_abrechnung_emobil_strom === 1) ||
        // Erste Bearbeitung
        (!prevDataItem.hasOwnProperty('tid') && dataItem.seperate_abrechnung_emobil_strom_name !== 'Ja' && dataItem.seperate_abrechnung_emobil_strom === 1) ||
        // Spätere Bearbeitung
        (prevDataItem.hasOwnProperty('seperate_abrechnung_emobil_strom') && prevDataItem.seperate_abrechnung_emobil_strom !== 1 && dataItem.seperate_abrechnung_emobil_strom === 1) ||
        (prevDataItem.hasOwnProperty('seperate_abrechnung_emobil_strom_orig') && prevDataItem.seperate_abrechnung_emobil_strom_orig !== 1 && dataItem.seperate_abrechnung_emobil_strom_orig === 1)
    ) {
        if ((dataGlobal || {}).MODUL_SELECTED !== 'steuer') {
            showLadestromMessage();
        }
        return;
    }
}

function showLadestromMessage() {
    const msg = 'Der Stromverbrauch für den Betrieb von Wärmepumpen ist im Bereich "Wärme" zu erfassen - allerdings nur dann, wenn eine Abgrenzung vom restlichen Strom problemlos möglich ist. Das ist i.d.R. dann der Fall, wenn Sie einen Wärmepumpen-Tarif und somit einen separaten Stromzähler für Wärmepumpenstrom haben.' +
        '\n\n' +
        'Ladestrom für E-Fahrzeuge ist nach Möglichkeit im Bereich "Kraftstoffe" zu erfassen. Dies ist allerdings i.d.R. nur dann möglich, wenn betriebsintern über Ladesäulen / Wallboxen etc. geladen wird und die entsprechenden Verbrauchswerte dieser Geräte separat erfasst bzw. ausgelesen werden können. Hilfsweise können Sie den genutzten Ladestrom über den Durchschnittsverbrauch und die Jahresfahrleistung abschätzen.' +
        '\n\n' +
        'ACHTUNG: Wenn Sie Stromverbräuche für Wärmepumpen im Bereich "Wärme" und/oder E-Autos im Bereich "Kraftstoffe" eintragen, achten Sie bitte unbedingt darauf, hier in der regulären Stromdatenerfassung, den Wert im Erfassungsfeld "Bezugsmenge vom Versorgungsunternehmen [kWh]" entsprechend zu verringern (da sich ansonsten ein überhöhter Gesamtstromverbrauch ergibt)!' +
        '\n\n' +
        'Lassen sich der Wärmepumpen- bzw. E-Fahrzeug-Ladestrom nicht separat ermitteln, sollte dies bei der Beurteilung der eigenen Datenauswertung berücksichtigt werden: Der Stromverbrauch ist dann unverhältnismäßig hoch und der Wärme- bzw. Kraftstoffverbrauch unverhältnismäßig gering.';
    alert(msg);
}

function showStromDritteMessage(dataGlobal: any) {
    let msg: string;
    if (dataGlobal && dataGlobal.MODUL_SELECTED === 'steuer') {
        msg = 'Sofern ein Teil des von Ihrem Energieversorgungsunternehmens gelieferten Stroms an Dritte weitergegeben wird (Mieter:innen, öffentl. Ladestationen etc.), tragen Sie bitte hier NUR den Anteil in kWh ein, der tatsächlich im eigenen Betrieb verbraucht wird.'
            + '\n\n'
            + 'Tragen Sie bitte die weitergeleitete Strommenge (also den Anteil Ihrer Gesamtstromrechnung, der NICHT für eigene Betriebszwecke verbraucht wurde) in das Feld „Weitergeleitete Strommenge“ ein.';
    } else {
        msg = 'Sofern ein Teil des von Ihrem Energieversorgungsunternehmens gelieferten Stroms an Dritte weitergegeben wird (Mieter:innen, öffentl. Ladestationen etc.), bitte berücksichtigen, dass hier nur der Anteil in kWh einzutragen ist, der tatsächlich im Betrieb verbraucht wird.';
    }
    alert(msg);
}

export function getAssistentConfigEigenStrom(standort: any, data: any, customCfg?: AssistentItem): AssistentItem {
    const eingabe_strom = {
        gliederung: '2.1.1',
        name: 'Eigenstrom',
        description: 'Dies ist das Formular zur Eingabe der Strom-Daten.',
        type: 'EntityForm',
        addLabel: 'Neuen Eigenstrom-Datensatz erfassen',
        entity: IDs.ENT_ENERGIEDATEN_EIGENSTROM,
        style: { marginLeft: '18px' },
        configFlag: 'inputEigenstrom',
        customTopElement: (entity: string, item: any, callback?: (data: any) => void) =>
            <EigenstromButtonWrapper
                data={data}
                standortSelected={standort}
            />,
        ... (customCfg || {})
    };
    return eingabe_strom;
}
